import { creditLimitService } from '@afterpaytouch/portal-api/consumer/creditLimit'

export const {
  useGetCreditLimitQuery,
  useGetConsumerLendingCreditLimitQuery,
  useGetConsumerLendingDecreaseCreditLimitOptionsQuery,
  useDecreaseConsumerLendingCreditLimitMutation,
} = creditLimitService
